module.exports = __webpack_public_path__ + "static/app-animation-2be863ce1e051cb8d39f40b06ea2f1ab.webm";